import { useState, useMemo } from 'react';

const useNivoLine = ({ data,
                         xScale = { type: 'linear' },
                         yScale = { type: 'linear', min: 'auto', max: 'auto', stacked: false }, // Allow min and max to be calculated automatically
                         isArea = true,
                         areaOpacity = 0.1,
                         lineWidth = 2,
                         enablePoints = true,
                         pointSize = 5,
                         xTitle='Holdings',
                         yTitle='Change (%)',

}) => {

    const [config, setConfig] = useState({
        xScale,
        yScale,
        isArea,
        lineWidth,
        pointSize,
        areaOpacity,
        enablePoints,
        xTitle,
        yTitle
    })

    const chartData = useMemo(() => data, [data]);

    return {
        chartData,
        config, setConfig

    };
};

export default useNivoLine;
